import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M1.16,7.4l9.64,4.19a3,3,0,0,0,2.4,0L22.85,7.4A1.52,1.52,0,0,0,23.75,6a1.48,1.48,0,0,0-.91-1.37L13.2.45a3,3,0,0,0-2.4,0L1.16,4.65A1.48,1.48,0,0,0,.25,6,1.51,1.51,0,0,0,1.16,7.4Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M22.84,10.65l-1.24-.54a1,1,0,0,0-.8,0L12,13.93,3.2,10.11a1,1,0,0,0-.8,0l-1.24.54a1.49,1.49,0,0,0,0,2.75l9.64,4.19a3,3,0,0,0,2.4,0l9.64-4.19A1.51,1.51,0,0,0,23.75,12,1.48,1.48,0,0,0,22.84,10.65Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M22.84,16.6l-1.24-.54a1,1,0,0,0-.8,0L12,19.89,3.2,16.06a1,1,0,0,0-.8,0l-1.24.54A1.51,1.51,0,0,0,.25,18a1.48,1.48,0,0,0,.91,1.37l9.64,4.2a3,3,0,0,0,2.4,0l9.64-4.2A1.48,1.48,0,0,0,23.75,18,1.51,1.51,0,0,0,22.84,16.6Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }